// extracted by mini-css-extract-plugin
export var browserArea = "styles-module--browserArea--09fe7";
export var headerNav = "styles-module--headerNav--8a61b";
export var mainWrapper = "styles-module--mainWrapper--2a003";
export var toggleSpacer = "styles-module--toggleSpacer--c0c23";